/**
 * @param {string} multiplierParam query param people multiplier
 * @param {object} peopleMultipliers list of query params people multipliers
 * @returns {integer} if there is not a value in the corresponding multiplierParam
 * it would search for the next one and return it. (this would happen when only 1 product with people is selected)
 */
export const getPeopleMultiplier = (multiplierParam, peopleMultipliers) => {
  let people = 1;
  const queryParam = multiplierParam
    ? peopleMultipliers[multiplierParam]
    : null;
  if (queryParam) {
    people = queryParam;
  } else {
    for (let qparam in peopleMultipliers) {
      if (peopleMultipliers[qparam] !== '') {
        people = peopleMultipliers[qparam];
        break;
      }
    }
  }
  return people;
};
